export default "__VITE_ASSET__DCXVQxkx__"